import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || "https://www.easygutachter.de";

/**
 * PublicLegalPage — Layout-freie Variante für anonym zugängliche Rechtstexte.
 * Genutzt für AGB / Datenschutz / Sicherungsabtretung auf /legal/*
 */
export default function PublicLegalPage({ title, subtitle, lastUpdated, children, testid }) {
  return (
    <div className="min-h-screen bg-zinc-50" data-testid={testid}>
      <header className="bg-white border-b border-zinc-200">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href={WEBSITE_URL} className="flex items-center gap-2" data-testid="legal-brand">
            <img src="/easy-gutachter-logo.png" alt="Easy Gutachter" className="h-10 w-auto" />
          </a>
          <Link
            to="/register"
            className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-zinc-900 transition-colors"
            data-testid="legal-back-to-register"
          >
            <ArrowLeft className="h-4 w-4" /> Zurück zur Registrierung
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10">
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-zinc-900">{title}</h1>
        {subtitle && <p className="text-zinc-500 mt-2">{subtitle}</p>}
        {lastUpdated && (
          <p className="text-xs text-zinc-400 mt-4 uppercase tracking-wider font-semibold">
            Stand: {lastUpdated}
          </p>
        )}
        <div className="mt-8 bg-white border border-zinc-200 rounded-2xl p-6 sm:p-8 leading-relaxed text-[15px]">
          <div className="space-y-3 text-zinc-700 [&_h2]:font-display [&_h2]:tracking-tight [&_h2]:font-bold [&_h2]:text-xl [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-zinc-900 [&_h3]:font-display [&_h3]:tracking-tight [&_h3]:font-semibold [&_h3]:text-lg [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-zinc-900 [&_p]:leading-relaxed [&_p]:my-3 [&_a]:text-emerald-700 [&_a]:underline [&_a]:underline-offset-2 [&_strong]:text-zinc-900 [&_strong]:font-semibold [&_ul]:my-3 [&_ul]:pl-6 [&_ul]:list-disc [&_li]:my-1.5">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
}
